/**
 * Part of eden40 project.
 *
 * @copyright  Copyright (C) 2022 __ORGANIZATION__.
 * @license    __LICENSE__
 */

import '@vendor/lottie-web/build/player/lottie.min.js?2d869d7ab7d56ac3052db866';

const carouselAniData = {
  container: document.getElementById('carousel-animation'),
  renderer: 'svg',
  loop: false,
  autoplay: true,
  path: 'assets/js/front/home/home-animation.json',
  assetsPath: u.uri('asset').root + 'images/home/anim/'
  // animationData: banner
};

export const carouselAnimation = lottie.loadAnimation(carouselAniData);

window.backFrames = 384;

carouselAnimation.addEventListener('complete', () => {
  console.log('Completed');
  carouselAnimation.goToAndPlay(
    carouselAnimation.totalFrames - window.backFrames,
    true
  );
});
